import React, { useContext } from 'react';
import BrightcoveVideoPlayer from '../BrightcoveVideoPlayer/BrightcoveVideoPlayer';

import { FlowContext } from '../../core/flow-engine';
import { MFBeaconButton } from '../Beacon/BeaconComponents';
import styles from './style.css';
import { redirectToAPP } from './util';
import Heading from '../Typography/Heading/Heading';
import SubHeading from '../Typography/SubHeading/SubHeading';

const ActivelyManagedPortfolio = () => {
  const { back, appState } = useContext(FlowContext);
  const applicationID = appState.store.app.profileApplicationID;
  const title = (
    <span>
      The T. Rowe Price ActivePlus Portfolios<sup>&reg;</sup> Program
    </span>
  );

  return (
    <>
      <div className="headers-wrapper">
        <Heading text={title} />
        <SubHeading text="A portfolio of funds expertly selected and managed" />
      </div>
      <div className="app-container">
        <div className="app-text">
          <b>The T. Rowe Price</b> ActivePlus Portfolios<sup>&reg;</sup> program
          is a convenient way to invest based on your time line and risk
          tolerance. Complete a short questionnaire and we’ll recommend a
          diversified model portfolio designed and actively managed by our
          experts.
        </div>
        <div className="app-text">
          Our investment professionals actively monitor markets, allocate
          assets, rebalance as needed, and explore long-term investment
          opportunities &mdash; so you don&apos;t have to.
        </div>
        <div className="app-text">
          There are no additional advisory fees or commissions for this program.
          You pay the expenses of the underlying T. Rowe Price funds in your
          account.
        </div>

        <div className="video-title">Watch and learn about key benefits</div>
        <div className="video-player">
          <BrightcoveVideoPlayer
            videoID="5211589269001"
            accountID="1305038892"
            playerID="r1fQk6Ip"
          />
        </div>
      </div>
      <div className="button-container">
        <MFBeaconButton
          data-no-warn
          variant="primary"
          size="normal"
          id="getStartedActivePlusPortfolio"
          className="beacon-button-margin-override"
          onClick={() => redirectToAPP(applicationID)}
          label="Get Started"
        />
        <MFBeaconButton
          variant="secondary"
          size="normal"
          id="activePlusPortfolioBack"
          className="beacon-button-margin-override"
          onClick={back()}
          label="Back to select investments"
        />
      </div>

      <div className="app-faq">
        Questions? Review our{' '}
        <a
          href="https://www3.troweprice.com/usis/personal-investing/products-and-services/activeplus-portfolios/faqs.html"
          target="_blank"
          rel="noopener noreferrer">
          T. Rowe Price ActivePlus Portfolios<sup>&reg;</sup> program FAQs
        </a>{' '}
        or call <span className="text-nowrap">1-800-401-1868</span> weekdays
        between 8 a.m. and 8 p.m. ET for assistance.
      </div>

      <div className="legal-container">
        <div className="legal-text">
          Investments in The T. Rowe Price ActivePlus Portfolios<sup>&reg;</sup>{' '}
          program are subject to the risks associated with investing in mutual
          funds, which may result in loss of principal. T. Rowe Price does not
          guarantee the results of our investment management, or that the
          objectives of the funds or the portfolios will be met.
        </div>
        <div className="legal-text">
          The T. Rowe Price ActivePlus Portfolios<sup>&reg;</sup> program is a
          discretionary investment management program provided by T. Rowe Price
          Advisory Services, Inc., a registered investment adviser under the
          Investment Advisers Act of 1940. Brokerage services are provided by T.
          Rowe Price Investment Services, Inc., member FINRA/SIPC. Brokerage
          accounts are carried by Pershing LLC, a BNY Mellon Company, member
          NYSE/FINRA/SIPC. T. Rowe Price Advisory Services, Inc., and T. Rowe
          Price Investment Services, Inc., are affiliated companies.
        </div>
      </div>

      <style jsx>{styles}</style>
    </>
  );
};

export default ActivelyManagedPortfolio;
